import { ARC4U_IDENTIFIER } from '@libs/renegkit';

export const ARC_IDENTIFIERS = new Set(['arc', 'arc4', ARC4U_IDENTIFIER]);

export function isArcIdentifier(id?: string): boolean {
  return !!id && ARC_IDENTIFIERS.has(id);
}

